import React from 'react';
import { useTranslation } from 'react-i18next';

import { PublicFooter } from '../common/PublicFooter';

import FigoBackground from '../../assets/login/login-background.svg';
import PetCloudBanner from '../../assets/pet-cloud-logo.svg';

import './LoginMobile.css';

const LoginMobileCaScreen = () => {
  const { t } = useTranslation('loginScreen');

  return (
    <div className="Login-mobile">
      <div className="Login-mobile-container">
        <div className="Login-pet-cloud-banner">
          <img alt="" src={PetCloudBanner} />
        </div>

        <img
          alt=""
          className="Login-mobile-figo-background"
          src={FigoBackground}
        />

        <div className="Login-mobile-background-content">
          <h1>{t('loginMobile.welcome')}</h1>

          <p>{t('loginMobile.textAppPPU')}</p>

          <h1>{t('loginMobile.welcomePPU')}</h1>

          <p>{t('loginMobile.textAppForPPU')}</p>
        </div>

      </div>

      <PublicFooter />
    </div>
  );
};

export { LoginMobileCaScreen };
